/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';
import { CHANGE_PASSWORD } from '../../api/graphql/changePassword.mutation';
import { getErrorMessage } from '@/utils/error.message';

export interface IChangePasswordMethods extends IPluginMethodMap {
  changePassword(args?: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class ChangePasswordService implements IAgentPlugin {
  readonly methods: IChangePasswordMethods;

  constructor() {
    this.methods = {
      changePassword: this.changePassword.bind(this),
    };
  }

  async changePassword(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig?.gql?.url);
    console.log('data in query', args?.token);
    if (args?.token) {
      gql = gql.withHeaders({
        authentication: args?.token,
      });
    }
    const client = gql.getClient();

    const storageSrv = StorageModule.getInstance();
    const _localData = storageSrv.get('userProfile', 'local');
    const _sessionData = storageSrv.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;

    console.log('data in query', args);
    try {
      if (client) {
        console.log(client);
        const res = await client
          .mutation(CHANGE_PASSWORD, {
            input: {
              newPassword: args?.password,
              oldPassword: args?.oldpassword,
            },
          })
          .toPromise();
        console.log('profileress->', res);
        if (res?.data?.updatePassword) {
          return {
            ...res?.data,
          };
        }
        getErrorMessage(res?.error);
        throw res?.error;
      }
    } catch (err: any) {
      console.log(`validateEmail error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
